<div  *ngIf="isloaded; else loading" style="overflow-y: scroll">
  <div class="margin-to-top success-container">
    <ion-col size="3">
      <ion-button
        id="btn-go-back"
        class="button-back"
        fill="clear"
        routerLink="/home/ccv/detail"
      >
        <left-arrow-svg class="button-back-icon"></left-arrow-svg>
        <chevron-back-svg class="chevron-back-icon"></chevron-back-svg>
        Volver al detalle
      </ion-button>
    </ion-col>
    <div class="circle">
      <check-svg></check-svg>
    </div>

    <h1 class="title mt-16">
      Tu cambio de Régimen Tributario se realizó con éxito
    </h1>

    <h2 class="mt-32 body-desktop bold primary-color">¿Qué viene ahora?</h2>

    <p class="header">
      Le avisaremos a tu empleador para que realice la modificación.

      <span class="bold primary-color">
        Te sugerimos verificar que haya recibido la información.
      </span>
    </p>
    <br />

    <h2 class="body-desktop bold primary-color">Este es tu comprobante</h2>

    <p class="header">
      También lo enviamos a tu correo
      <span class="underlineText">{{ user.email }}</span> En caso de no
      encontrarlo en tu bandeja principal, por favor, revisa tu spam.
    </p>
    <hr class="linea" />
    <ion-grid class="mb-32">
      <ion-row class="text-secondary">
        <ion-col size="6">
          <p class="body-desktop-regular marginFolio">Nº Folio:</p>
        </ion-col>

        <ion-col size="6">
          <p class="body-desktop-regular marginFolio">
            {{ finalRegimen.folio }}
          </p>
        </ion-col>
      </ion-row>

      <hr />
      <ion-row class="text-secondary">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12">
            Nuevo Régimen <br />
            tributario:
          </p>
        </ion-col>
        <ion-col size="6">
          <p class="amount mb-0 mt-12 bold">
            {{ finalRegimen.taxRegimeCode }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12">Fecha de solicitud:</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12">{{ formatDate(today) }}</p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12">Comienzo de ajuste:</p>
        </ion-col>

        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12">
            {{ nextMonthInSpanish }}
          </p>
        </ion-col>
      </ion-row>
      <hr />
      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12">
            <strong>Datos Empleador</strong>
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">
            Nombre:
          </p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ finalRegimen.employer.name }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">Rut:</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ stringToRutFormatted(finalRegimen.employer.rut+finalRegimen.employer.checkDigit)}}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">Correo:</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ finalRegimen.employer.email }}
          </p>
        </ion-col>
      </ion-row>
      <hr />

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12">
            <strong>Tus datos</strong>
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">Nombre:</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ user.name }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">Rut:</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ stringToRutFormatted(user.rut) }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">Correo:</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ user.email }}
          </p>
        </ion-col>
      </ion-row>
      <hr />
      <ion-row
        class="text-secondary primary-color footnote-desktop-regular mb-12"
      >
        <ion-col size="12">
          <p class="mb-0 bold">Ten en cuenta que:</p>
          <p class="ion-no-margin">
            · Al realizar este cambio, el beneficio de cada
            régimen será proporcional a su tiempo de
            permanencia
          </p>
          <p class="ion-no-margin">
            · El aporte desde tu sueldo se realizará cada mes.
          </p>
          <p class="ion-no-margin">
            · La rentabilidad obtenida es variable en el tiempo
          </p>
        </ion-col>
      </ion-row>
      <ion-row
        style="padding: 0"
        class="mt-24 width-percent-100"
        (window:resize)="onResize($event)"
      >
        <ion-col size="12" class="width-percent-100" *ngIf="!isMobile">
          <ion-button
            id="btn-download-pdf"
            class="mt-0 btn-suscribe"
            (click)="downloadMyFile()"
            (keypress)="true"
          >
            <ion-label class="control-step-button-text font-weight-700">
              {{ downloadButtonLabel }}
            </ion-label>
            <span class="apv-button-arrow-container ml-24">
              <download-svg></download-svg>
            </span>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
<ng-template #loading>
  <div class="container-spinner">
    <div class="loader"></div>
    <h2>Cargando, por favor espera </h2>
  </div>

</ng-template>
